/* istanbul ignore file */
import React, { ReactElement } from "react";
import { DefaultHoofdstuk } from "../../../.generated/rapportage/rapportagetypes";
import { Paragraph } from "../components/Paragraph";
import Heading from "../components/Heading";
import { Chapter } from "../components/Chapter";

type InleidingProps = {
  inleiding: DefaultHoofdstuk;
};

export const Inleiding = ({ inleiding }: InleidingProps): ReactElement => {
  return (
    <Chapter className="inleiding">
      {inleiding.titel && <Heading text={inleiding.titel}></Heading>}

      {inleiding.paragrafen &&
        Object.keys(inleiding.paragrafen).map((key) => {
          const paragraaf = inleiding.paragrafen && inleiding.paragrafen[key];
          return (
            paragraaf && (
              <Paragraph paragraaf={paragraaf} key={paragraaf.code} />
            )
          );
        })}
    </Chapter>
  );
};
